import React, { useState } from 'react'

import keyUpHandler from '../utils/keyUpHandler'

import VideoModal from '../generic/VideoModal'

function HeroBanner({
  title,
  bannerDesktop,
  bannerMobile,
  videoUrl,
  subtitleUrl,
  hasOverlay
}) {
  const [showVideo, setShowVideo] = useState(false)
  return (
    <>
      <button
        aria-label="Show video"
        className="banner-holder"
        onClick={() => setShowVideo(true)}
        onKeyUp={(event) =>
          keyUpHandler(event, () => setShowVideo(true), null, this)
        }
        tabIndex="0"
        type="button"
        style={{ width: '100%' }}
      >
        <picture>
          <source media="(max-width: 799px)" srcSet={bannerMobile} />
          <source media="(min-width: 800px)" srcSet={bannerDesktop} />
          <img
            src={bannerDesktop}
            alt="Stan Winston School of Character Arts"
          />
        </picture>
        {hasOverlay && <div className="overlay" />}
        <div className="banner-content">
          {title && <h1>{title}</h1>}
          <i className="icon-play" />
        </div>
      </button>
      <VideoModal
        url={videoUrl}
        visible={showVideo}
        close={() => setShowVideo(false)}
        subtitles={subtitleUrl}
      />
    </>
  )
}

export default HeroBanner
